import { baseUrl } from '../../utils/constants';
import { client } from '../client';
import {
  EVENTS,
  ALLEVENTS,
  CREATEEVENTTAGS,
  CREATETAG,
  UPDATETAG,
  GETALLTAGS,
  REMOVETAG,
  GETTAGRESPONSESBYEVENTID,
  GETEVENTUSERS,
  EVENTNAMES,
  GETTAGRESPONSESBYEVENTMSGID,
} from '../endpoints';

// Fetch all events
export const getAllEvents = async () => {
  try {
    const response = await client.get(`${baseUrl}${ALLEVENTS}`);
    return response;
  } catch (error) {
    console.error('Error fetching all events:', error);
  }
};

// Fetch all event tags
export const getEventTags = async () => {
  try {
    const response = await client.get(`${baseUrl}${EVENTS}`);
    return response;
  } catch (error) {
    console.error('Error fetching event tags:', error);
  }
};

export const addEventTag = async ({
  eventName,
  description,
  startTime,
  endTime,
  usersToAssign,
  tagsToAssign,
}: // date,
// status,
// tags,
{
  eventName: string;
  description: string;
  startTime?: string;
  endTime?: string;
  usersToAssign?: number[];
  tagsToAssign: number[];
}) => {
  try {
    const response = await client.post(`${baseUrl}${CREATEEVENTTAGS}`, {
      eventName,
      description,
      startTime,
      endTime,
      usersToAssign,
      tagsToAssign,
    });
    return response;
  } catch (error) {
    console.error('Error adding event tag:', error);
  }
};

export const getEventUsers = async (eventId: string) => {
  try {
    const response = await client.get(`${baseUrl}${GETEVENTUSERS}/${eventId}`);
    return response;
  } catch (error) {
    console.error('Error fetching event users:', error);
  }
};

export const addTagStatus = async ({
  eventTagId,
  status,
}: {
  eventTagId: string;
  status: string;
}) => {
  try {
    const response = await client.post(
      `${baseUrl}${EVENTS}/${eventTagId}/statuses`,
      { statusName: status }
    );
    return response;
  } catch (error) {
    console.error('Error adding tag status:', error);
  }
};

export const deleteEvent = async (eventId: number) => {
  try {
    const response = await client.delete(
      `${baseUrl}/eventtags/deleteevent/${eventId}` // Ensure the correct endpoint is used
    );
    return response;
  } catch (error) {
    console.error('Error deleting event:', error);
  }
};

export const updateEvent = async ({
  eventId,
  eventName,
  description,
  startTime,
  endTime,
  usersToAssign,
  tagsToAssign,
  status,
}: {
  eventId: string;
  eventName: string;
  description: string;
  startTime?: string;
  endTime?: string;
  usersToAssign: number[];
  tagsToAssign: number[];
  status?: number;
}) => {
  try {
    const response = await client.put(`${baseUrl}/eventtags/updateevent`, {
      eventId,
      eventName,
      description,
      startTime,
      endTime,
      usersToAssign,
      tagsToAssign,
      status,
    });
    return response;
  } catch (error) {
    console.error('Error updating event:', error);
  }
};

export const getEventById = async (eventId: string) => {
  try {
    const response = await client.get(`${baseUrl}/eventtags/event/${eventId}`);
    return response;
  } catch (error) {
    console.error('Error fetching event by ID:', error);
  }
};

export const createTag = async ({
  tagName,
  description,
  colour,
}: {
  tagName: string;
  description: string;
  colour: string;
}) => {
  const response = await client.post(`${baseUrl}${CREATETAG}`, {
    tagName,
    description,
    colour,
  });
  return response;
};

export const updateTag = async ({
  eventTagId,
  tagName,
  description,
  colour,
}: {
  eventTagId: number;
  tagName: string;
  description: string;
  colour: string;
}) => {
  const response = await client.put(`${baseUrl}${UPDATETAG}`, {
    eventTagId,
    tagName,
    description,
    colour,
  });
  return response;
};

export const getAllTags = async () => {
  const response = await client.get(`${baseUrl}${GETALLTAGS}`);
  return response;
};

export const removeTag = async (eventTagId: number) => {
  const response = await client.delete(`${baseUrl}${REMOVETAG}${eventTagId}`);
  return response;
};

export const getTagResponsesByEventId = async (eventId: number) => {
  const response = await client.get(
    `${baseUrl}${GETTAGRESPONSESBYEVENTID}${eventId}/count`
  );
  return response;
};

export const getEventsGrid = async ({
  page,
  size,
  q,
}: {
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(`${baseUrl}${EVENTNAMES}`, {
    params: {
      page,
      size,
      q,
    },
  });
  return response;
};

export const getTagResponsesByEventMsgId = async ({
  eventId,
  messageId,
}: {
  messageId: number;
  eventId: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETTAGRESPONSESBYEVENTMSGID}${messageId}/event/${eventId}/count`
  );
  return response;
};
